function isImageElement(element) {
  return element.nodeName === 'IMG';
}

function defineImagesToUpdate(element) {
  return isImageElement(element) ? [element] : Array.from(element.children).filter(isImageElement);
}

export function checkForIntersectionWrapper(timeout) {
  return function checkForIntersection(entries, observer) {
    entries.forEach(entry => {
      setTimeout(() => {
        if (!entry.isIntersecting) {
          return;
        }

        loadImage(entry);
        observer.unobserve(entry.target);
      }, timeout);
    });
  };
}

export function loadImage(entry) {
  const element = entry.target || entry;
  const dataSrc = element.dataset.src;

  /* istanbul ignore else  */
  if (!element.src) {
    element.src = dataSrc;
  }
}

export default function ImageLoader(element, options) {
  const timeout = (options && options.timeout) || 0;

  const imageCollection = element instanceof window.NodeList
    ? Array.from(element)
    : defineImagesToUpdate(element);

  if (!window.IntersectionObserver) {
    return imageCollection.forEach(loadImage);
  }

  const observer = new IntersectionObserver(checkForIntersectionWrapper(timeout), options);
  imageCollection.forEach(observer.observe, observer);

  return observer;
}
